/**
 * financialYearHelper.js
 * Shared utility for Indian Financial Year (April–March) helpers.
 * Single source of truth — import from here everywhere in the project.
 */

/**
 * Generate a list of financial years from the current FY back to 2019-2020.
 * Indian FY starts in April, so April–March is one FY.
 *
 * @returns {string[]} e.g. ["2025-2026", "2024-2025", ..., "2019-2020"]
 */
export const generateDefaultFinancialYears = () => {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;

  // Current FY start year
  const currentFY = currentMonth >= 4 ? currentYear : currentYear - 1;

  const years = [];

  for (let startYear = currentFY; startYear >= 2019; startYear--) {
    years.push(`${startYear}-${startYear + 1}`);
  }

  return years;
};

/**
 * Returns the current FY string, e.g. "2025-2026".
 * @returns {string}
 */
export const getCurrentFinancialYear = () => {
  return generateDefaultFinancialYears()[0];
};
